// extracted by mini-css-extract-plugin
export var aboveInput = "_hc-0";
export var actionButton = "_hc-5";
export var actionButtonContainer = "_hc-1";
export var actionIcon = "_hc-6";
export var aiInfoContainer = "_hc-2";
export var attachmentWrapper = "_hc-7";
export var bold = "_hc-3";
export var checkIcon = "_hc-8";
export var clickingRecipientBar = "_hc-11";
export var commentThreadSwitch = "_hc-a";
export var draftImage = "_hc-b";
export var draftImageContainer = "_hc-c";
export var draftImages = "_hc-e";
export var editButton = "_hc-g";
export var editor = "_hc-f";
export var editorContainer = "_hc-y";
export var editorErrorTooltipWrapper = "_hc-9";
export var headerDivider = "_hc-h";
export var icon = "_hc-i";
export var info = "_hc-j";
export var internal = "_hc-n";
export var internalDivider = "_hc-k";
export var internalMessage = "_hc-l";
export var messageInputCard = "_hc-m";
export var messageInputForm = "_hc-o";
export var messageInputFormInternal = "_hc-p";
export var options = "_hc-q";
export var publicMessageCustomer = "_hc-s";
export var publicMessageMerchant = "_hc-r";
export var removeImageButton = "_hc-d";
export var replyButtons = "_hc-t";
export var showSignatureButton = "_hc-u";
export var spinner = "_hc-v";
export var verticalButtonDivider = "_hc-4";
export var visibilitySelector = "_hc-w";
export var warning = "_hc-x";
export var wrappingText = "_hc-z";
export var writingInternalNoteTopBorder = "_hc-10";